exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cover-photo[data-v-1ab0a014]{position:relative;float:left;width:100%;height:15rem;background:no-repeat 50% 50%;object-fit:scale-down;background-size:cover;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ab0a014","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Album.vue
// module id = 397
// module chunks = 0